
<script>
import {bankingTransactionsQris as columns} from '../../../tables'

export default {
  name: "banking-transaction-qris",
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('hyperion.finances.banking-transactions-qris')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      loadingDownload: false,
      modal: {
        visible: false,
        item: {}
      },
      modalResp: {
        visible: false,
        item: {}
      },
      filters: {
        page: 1,
        per_page: 10,
        date: [],
        products: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        page: 1,
        per_page: 10,
        terminal_id: '',
        merchant_id: '',
        service: '',
        merchant_name: '',
        q: '',
        date: []
      }
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    handleDownload(e) {
      this.loadingDownload = true

      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime(),
        format: e.key
      })

      this.$http.get(this.routeUri('hyperion.finances.banking-transactions-qris.export') + '?' + this.$qs.stringify(params))
      .then(() => {
        this.handleSuccessResponse()
      })
      .catch((error) => this.handleResponseError(error))
      .finally(() => this.loadingDownload = false)
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Success!',
        description: 'File excel ready to download, available at download center menu'
      })
      setTimeout(() => window.location.href = data.redirect, 2000)
    },
    handleResponseError(data) {
      this.$notification.error({
        message: "Failed",
        description: "We are unable to export your data."
      })
    }
  }
}
</script>

<template>
  <a-card size="small" type="inner" :title="items.total > 0 ? 'QRIS Transaction '+items.total +' record(s)' : 'QRIS Transaction'">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">

        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>

        <a-col :span="6">
          <a-input placeholder="Merchant ID" v-model="filters.merchant_id" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-input placeholder="Terminal ID" v-model="filters.terminal_id" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-input placeholder="Branch Code" v-model="filters.branch_code" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-select v-model="filters.status" placeholder="please select your status">
            <a-select-option value="sukses">Success</a-select-option>
            <a-select-option value="gagal">Failed</a-select-option>
            <a-select-option value="pending">Pending</a-select-option>
          </a-select>
        </a-col>

      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}"
                    :loading="loadingDownload">Search
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}"
                    :loading="loadingDownload">Reset
          </a-button>

          <a-dropdown>
            <a-menu slot="overlay" @click="handleDownload">
              <a-menu-item key="xlsx">
                <a-icon type="file-excel" theme="twoTone" two-tone-color="#52c41a"/> XLSX
              </a-menu-item>
            </a-menu>
            <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" :style="{ display: expand ? 'inline-block' : 'none'}" :loading="loadingDownload"/>
          </a-dropdown>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="transaction_ref_id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged" :scroll="{ x: 2500, y: 500 }">
        <h5 slot="datetime" slot-scope="record" class="text-center">
          {{ moment(record).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <h5 slot="merchant_code" slot-scope="record">
          {{ record.merchant_code }}
        </h5>

        <h5 slot="mid" slot-scope="record">
          {{ record.mid }}
        </h5>

        <h5 slot="tid" slot-scope="record">
          {{ record.tid }}
        </h5>

        <h5 slot="mpan" slot-scope="record">
          {{ record.mpan }}
        </h5>

        <h5 slot="cpan" slot-scope="record">
          {{ record.cpan }}
        </h5>

        <h5 slot="nmid" slot-scope="record">
          {{ record.nmid }}
        </h5>

        <h5 slot="nmid_qris" slot-scope="record">
          {{ record.nmid_qris }}
        </h5>

        <h5 slot="tid_qris" slot-scope="record">
          {{ record.tid_qris }}
        </h5>

        <h5 slot="branch_code" slot-scope="record">
          {{ record.branch_code }}
        </h5>

        <h5 slot="batch_no" slot-scope="record">
          {{ record.batch_no }}
        </h5>

        <h5 slot="account_number" slot-scope="record">
          {{ record.account_number }}
        </h5>

        <h5 slot="pan" slot-scope="record">
          {{ record.pan }}
        </h5>

        <h5 slot="product" slot-scope="record">
          {{ record.product }}
        </h5>

        <h5 slot="service_type" slot-scope="record">
          {{ record.service_type }}
        </h5>

        <h5 slot="customer_name" slot-scope="record">
          {{ record.customer_name }}
        </h5>

        <h5 slot="issuer_name" slot-scope="record">
          {{ record.issuer_name }}
        </h5>

        <h5 slot="amount" slot-scope="record" class="text-right">
          {{ record.amount }}
        </h5>

        <h5 slot="stan" slot-scope="record">
          {{ record.stan }}
        </h5>

        <h5 slot="rrn" slot-scope="record">
          {{ record.rrn }}
        </h5>

        <h5 slot="sn" slot-scope="record">
          {{ record.sn }}
        </h5>

        <h4 slot="response_code" slot-scope="record">
          {{ record.response_code }}
        </h4>

        <h4 slot="response_message" slot-scope="record">
          {{ record.response_message }}
        </h4>

        <h4 slot="status" slot-scope="record">
          {{ record.status }}
        </h4>

        <div slot="raw" slot-scope="record">
          <a-tooltip title="Raw Response">
            <a-button size="small" icon="code" @click="() => modalResp = { visible: true, item: record.raw }"/>
          </a-tooltip>
        </div>

      </a-table>
    </a-skeleton>

    <a-modal title="Raw Response" v-model="modalResp.visible" @ok="() => modalResp = { visible: false, item: {} }">
      <div class="code-bg">
        <vue-json-pretty :data="modalResp.item" :deep="1"/>
        <div class="extra">
          <a-button type="link" icon="copy" size="small" @click="copy(JSON.stringify(modalResp.item, null, 1), 'Source has been successfully copied to your clipboard.')"/>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>
